/*
 * Are you confused about what view namespace are?
 * Are you curious about a few nuances with them, or the history of them?
 *
 * Take a look at the docs in this repo under /docs/viewNamespaces.md !
 */

export const VIEWS_NAMESPACE_NONE = 'NONE';
export const VIEWS_NAMESPACE_FORMS = 'FORMS';
export const VIEWS_NAMESPACE_TASKS = 'TASKS';